import { Components } from '@utahdts/dts-react-common';
import { makeFormattedTextChange } from '../../misc/textFieldFormatter';

// The literal fallbacks match dts-react-common's public Components values and
// keep this small wiring helper usable in tests that intentionally mock only a
// subset of that package.
const componentType = (name, fallback) =>
  Components && Components[name] ? Components[name] : fallback;

const TEXT_INPUT_TYPES = new Set([
  componentType('TEXT_INPUT', 'textInput'),
  componentType('TEXT_AREA', 'textArea'),
  componentType('CALENDAR_INPUT', 'calendarInput'),
  componentType('DELAYED_TEXT_INPUT', 'delayedTextInput'),
  componentType('DELAYED_TEXT_AREA', 'delayedTextArea'),
]);

// Every InputList validates its data during render. Wire text-like controls to
// format first, then update React state, so no validator ever sees an ExcelJS
// object or accidentally coerces it to "[object Object]". Selects and other
// structured controls retain their original callbacks and value types.
export default (inputs, onChange) => {
  const formattedTextChange = makeFormattedTextChange(onChange);
  Object.values(inputs).forEach((input) => {
    input.onChange = TEXT_INPUT_TYPES.has(input.type)
      ? formattedTextChange
      : onChange;
  });
  return inputs;
};
